import { render } from "./ArrowVue.vue?vue&type=template&id=5c52a8f8&scoped=true"
import script from "./ArrowVue.vue?vue&type=script&setup=true&lang=js"
export * from "./ArrowVue.vue?vue&type=script&setup=true&lang=js"

import "./ArrowVue.vue?vue&type=style&index=0&id=5c52a8f8&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5c52a8f8"],['__file',"src/components/auth/ArrowVue.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "5c52a8f8"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('5c52a8f8', __exports__)) {
    api.reload('5c52a8f8', __exports__)
  }
  
  module.hot.accept("./ArrowVue.vue?vue&type=template&id=5c52a8f8&scoped=true", () => {
    api.rerender('5c52a8f8', render)
  })

}


export default __exports__